import { historyList } from '@/mocks/homeData';

export default function HistoryTimeline() {
  return (
    <section id="history" className="border-y border-background-200 bg-background-100/60 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-secondary-700">往期 · HISTORY</p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              往期热门 · 时间线汇总
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              一段一段往回顺：每月新增、补档与重排都记在时间线上，完整版与汇总态一眼定位。
            </p>
          </div>
        </div>

        <div className="mt-8 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="hidden grid-cols-[1fr_2.5fr_1fr_auto] items-center gap-4 border-b border-background-200 bg-background-100 px-5 py-3 text-xs font-semibold uppercase tracking-wider text-foreground-500 md:grid">
            <span>时间</span>
            <span>收录内容</span>
            <span>说明</span>
            <span>状态</span>
          </div>
          <ul className="divide-y divide-background-200">
            {historyList.map((row) => (
              <li key={row.date + row.title}>
                <div className="grid grid-cols-2 gap-x-4 gap-y-2 px-5 py-4 transition-colors hover:bg-background-100/70 md:grid-cols-[1fr_2.5fr_1fr_auto] md:items-center">
                  <span className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-bold text-primary-700">
                    <span className="h-2 w-2 rounded-full bg-primary-500"></span>
                    {row.date}
                  </span>
                  <span className="col-span-2 mt-1 text-[15px] font-semibold text-foreground-950 md:col-span-1 md:mt-0">
                    {row.title}
                  </span>
                  <span className="col-span-2 hidden text-sm text-foreground-600 sm:block md:col-span-1">
                    {row.note}
                  </span>
                  <span className="col-span-2 flex items-center gap-2 md:col-span-1 md:justify-end">
                    <span className="inline-flex whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-semibold text-secondary-800">
                      {row.tag}
                    </span>
                    <span className="hidden whitespace-nowrap rounded-full border border-accent-200 bg-accent-50 px-2.5 py-0.5 text-[11px] font-semibold text-accent-700 sm:inline-flex">
                      {row.mark}
                    </span>
                  </span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}